import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "m-b-10px": ""
}
const _hoisted_2 = {
  "m-tb-0": "",
  style: {"font-weight":"600"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  "m-b-10px": ""
}
const _hoisted_5 = {
  "m-tb-0": "",
  style: {"font-weight":"600"}
}
const _hoisted_6 = {
  key: 1,
  "m-b-10px": ""
}
const _hoisted_7 = {
  "m-tb-0": "",
  style: {"font-weight":"600"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_space, {
            size: 10,
            wrap: ""
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("span", { "mute-primary": "" }, "Domain of Expertise", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, ":", -1)),
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.user.areaOfExpertise), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.user.startupExperience && _ctx.isTalent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.user.startupExperience.stages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_space, {
                  size: 10,
                  wrap: ""
                }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { "mute-primary": "" }, "Startup Stages", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("span", null, ":", -1)),
                    _createElementVNode("span", null, [
                      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.user.startupExperience.stages.join(", ")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.startupExperience.models)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_space, {
                  size: 10,
                  wrap: ""
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { "mute-primary": "" }, "Business Models", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("span", null, ":", -1)),
                    _createElementVNode("span", null, [
                      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.user.startupExperience.models.join(", ")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}